import { render, staticRenderFns } from "./UserProfileModal.vue?vue&type=template&id=316cd096&scoped=true"
import script from "./UserProfileModal.vue?vue&type=script&lang=js"
export * from "./UserProfileModal.vue?vue&type=script&lang=js"
import style0 from "./UserProfileModal.vue?vue&type=style&index=0&id=316cd096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316cd096",
  null
  
)

export default component.exports